module.exports = __webpack_public_path__ + "static/nav-menu-hand-136484fb931c25290a1bb51174ed3b76.svg";